export default "__VITE_ASSET__BlZ5v9Go__"